import { stream, streamSimple } from "./api/bedrock-converse-stream.ts";

export const bedrockProviderModule = {
	stream,
	streamSimple,
};
